<div class="cs-switch-container cs-switch-container--small cs-d-flex align-items-center" [ngClass]="{'disabled': params.disabled}">
    <label class="switch" for="checkbox_{{params.rowIndex}}">
        <input type="checkbox" id="checkbox_{{params.rowIndex}}" [disabled]="params.disabled" [(ngModel)]="params.status" (change)="onChangeStatusConfirmation()"/>
        <div class="slider round"></div>
    </label>
</div>
<app-common-modal-popups
    *ngIf="statusActivationConfirmation?.showModal"
    [modalConfig]="statusActivationConfirmation"
    (onCloseModal)="onCloseConfirmation($event,'activate')"></app-common-modal-popups>
